import api from './api';

export type DateRange = 'this_week' | 'this_month' | 'last_3_months' | 'last_6_months' | 'this_year' | 'all_time';

export interface TechnicianPerformance {
    user: {
        id: number;
        name: string;
    };
    open: number;
    closed: number;
    total: number;
}

export interface ManagerStatsResponse {
    technician_performance: TechnicianPerformance[];
}

export const getManagerStats = (userIds: number[], dateRange: DateRange | { start_date: string; end_date: string }) => {
    // Convert array to query parameters
    const userParams = userIds.map(id => `user_ids[]=${id}`).join('&');
    
    let dateParams = '';
    if (typeof dateRange === 'string') {
        // Predefined date range
        dateParams = `date_range=${dateRange}`;
    } else {
        // Custom date range
        dateParams = `start_date=${dateRange.start_date}&end_date=${dateRange.end_date}`;
    }
    
    return api.get<ManagerStatsResponse>(`/dashboard/manager-stats?${dateParams}&${userParams}`);
}; 